import { themeVariables } from "src/themeVariables";

const PROJECT_MENU_MAIN_SELECTOR = ".project-menu .m-inner ul.main";

function isProjectMenuCollapsed() {
  if (typeof document === "undefined") {
    return false;
  }

  const projectMenu = document.querySelector(".project-menu");
  const mainMenu = document.querySelector(PROJECT_MENU_MAIN_SELECTOR);
  return Boolean(
    projectMenu?.classList.contains("collapsed") ||
    mainMenu?.closest(".m-inner")?.classList.contains("collapsed")
  );
}

export function getVisibleProjectMenuBottom() {
  if (typeof document === "undefined") {
    return 0;
  }

  const mainMenu = document.querySelector(PROJECT_MENU_MAIN_SELECTOR);
  if (!mainMenu || isProjectMenuCollapsed()) {
    return 0;
  }

  return mainMenu.getBoundingClientRect().bottom;
}

export function getDraftControlsStickyAnchorBottom(editorToolbarRect) {
  if (isProjectMenuCollapsed()) {
    return editorToolbarRect?.top ?? 0;
  }

  const toolbarBottom = editorToolbarRect?.bottom ?? 0;
  return Math.max(toolbarBottom, getVisibleProjectMenuBottom());
}

export function getFixedContainingBlockRect(element) {
  let node = element?.parentElement;
  while (node) {
    const style = getComputedStyle(node);
    if (
      style.transform !== "none" ||
      style.filter !== "none" ||
      (style.perspective && style.perspective !== "none")
    ) {
      return node.getBoundingClientRect();
    }
    node = node.parentElement;
  }
  return { left: 0, top: 0 };
}

export function viewportToContainingBlockCoords(viewportLeft, viewportTop, containingBlockRect) {
  return {
    left: viewportLeft - containingBlockRect.left,
    top: viewportTop - containingBlockRect.top,
  };
}

function applyGeneratePanelViewportFixedStyles(panel, viewportTop, viewportLeft, width) {
  const containingBlockRect = getFixedContainingBlockRect(panel);
  const { left, top } = viewportToContainingBlockCoords(viewportLeft, viewportTop, containingBlockRect);

  panel.style.position = "fixed";
  panel.style.top = `${top}px`;
  panel.style.left = `${left}px`;
  panel.style.width = `${width}px`;
  panel.style.marginLeft = "0";
  panel.style.marginRight = "0";
  panel.style.right = "";
  panel.style.boxShadow = themeVariables.dropShadow1525;
  panel.style.zIndex = "10";
}

export function applyGeneratePanelFixedStyles(panel, mainContainerRect, toolbarRect) {
  applyGeneratePanelViewportFixedStyles(
    panel,
    getDraftControlsStickyAnchorBottom(toolbarRect),
    mainContainerRect.left,
    mainContainerRect.width,
  );
}

export function getGeneratePanelBottomDockOffset({ mainContainerRect, editorRect, panelRect, vStackPadding = 24 }) {
  const mainContainerHeight = mainContainerRect.bottom - mainContainerRect.top;
  const editorHeight = editorRect.bottom - editorRect.top;
  const panelHeight = panelRect.bottom - panelRect.top;
  return mainContainerHeight + editorHeight - panelHeight - vStackPadding;
}

export function applyGeneratePanelAbsoluteStyles(panel, top) {
  panel.style.position = "absolute";
  panel.style.top = `${top}px`;
  panel.style.left = "0";
  panel.style.right = "0";
  panel.style.width = "100%";
  panel.style.marginLeft = "";
  panel.style.marginRight = "";
  panel.style.boxShadow = themeVariables.dropShadow1525;
  panel.style.zIndex = "10";
}

export function applyGeneratePanelBottomDockedStyles(panel, mainContainerRect, editorRect, panelRect, vStackPadding = 24) {
  const top = getGeneratePanelBottomDockOffset({ mainContainerRect, editorRect, panelRect, vStackPadding });
  applyGeneratePanelAbsoluteStyles(panel, top);
}

export function clearGeneratePanelStickyStyles(panel) {
  panel.style.position = "";
  panel.style.top = "";
  panel.style.left = "";
  panel.style.right = "";
  panel.style.width = "";
  panel.style.marginLeft = "";
  panel.style.marginRight = "";
  panel.style.boxShadow = "none";
  panel.style.zIndex = "";
}
